module.exports = __webpack_public_path__ + "img/dialog.c1852b8f.png";